import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { VehicleEntity } from "./vehicle.entity";
import { VehicleService } from "./vehicle.service";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { VehicleController } from "./vehicle.controller";

@Module({
    imports: [
        TypeOrmModule.forFeature([VehicleEntity]),
    ],
    controllers: [VehicleController],
    providers: [VehicleService, ApplicationExceptionHandler]
})
export class VehicleModule {}

